//utility function that merges two objects
export const merge = (a: object, b: object) => {
  const result = Object.assign({}, a, b);
  for (const key in a) {
    if (
      !a[key as keyof typeof a] ||
      typeof b[key as keyof typeof b] !== 'object'
    )
      continue;
    Object.assign(result, {
      [key]: Object.assign(a[key as keyof typeof a], b[key as keyof typeof b]),
    });
  }
  return result;
};
